import Chart from "chart.js/auto";

Chart.register({
  id: "doughnutLabel",
  beforeDraw: function (chart) {
    if (chart.config.type !== "doughnut") return;
    const width = chart.width;
    const height = chart.height;
    const ctx = chart.ctx;
    const text = chart.config.options?.plugins?.doughnutLabel?.text;
    if (!text) return;

    ctx.save();
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.font = "bold 20px Arial";
    ctx.fillStyle = "#000";
    ctx.fillText(text.title, width / 2, height / 2 - 10);

    ctx.font = "bold 24px Arial";
    ctx.fillStyle = "#000";
    ctx.fillText(text.value, width / 2, height / 2 + 20);
    ctx.restore();
  },
});

export class PaymentCalculatorView {
  constructor() {
    this.firstChart = null;
    this.secondChart = null;
  }

  toggleSection(triggerElement, contentElement) {
    if (!contentElement.classList.contains("hidden")) {
      contentElement.classList.add("hidden");
      triggerElement.textContent = "Show Inputs";
    } else {
      contentElement.classList.remove("hidden");
      triggerElement.textContent = "Collapse Inputs";
    }
  }

  updateFirstChart(canvas, model) {
    if (!canvas) return;

    const estimatedProfit = model.estimatedProfitFromSelling;
    const downPayment = model.downPayment;
    const estimatedCostsBuy = model.estimatedCostsToBuy;
    const monthlyCostDiff = model.calcCumulativeMonthlyCostDifference;
    const totalAfter3Years = model.totalCashDifference;

    const profitColor =
      estimatedProfit >= 0
        ? "rgba(75, 192, 192, 0.7)"
        : "rgba(255, 206, 86, 0.7)";
    const profitHover =
      estimatedProfit >= 0
        ? "rgba(75, 192, 192, 1)"
        : "rgba(255, 206, 86, 1)";

    const monthlyDiffColor =
      monthlyCostDiff >= 0
        ? "rgba(255, 206, 86, 0.7)"
        : "rgba(75, 192, 192, 0.7)";
    const monthlyDiffHover =
      monthlyCostDiff >= 0
        ? "rgba(255, 206, 86, 1)"
        : "rgba(75, 192, 192, 1)";

    const pocketTitle = totalAfter3Years >= 0 ? "Pocketed" : "Spent";

    const chartData = {
      type: "doughnut",
      data: {
        labels: [
          "Estimated Profit",
          "Down Payment",
          "Estimated Costs to Buy",
          "Cumulative Monthly Cost Diff",
        ],
        datasets: [
          {
            data: [
              Math.abs(estimatedProfit),
              downPayment,
              estimatedCostsBuy,
              Math.abs(monthlyCostDiff),
            ],
            backgroundColor: [
              profitColor,
              "rgba(235, 87, 87, 0.7)",
              "rgba(242, 153, 74, 0.7)",
              monthlyDiffColor,
            ],
            hoverBackgroundColor: [
              profitHover,
              "rgba(235, 87, 87, 1)",
              "rgba(242, 153, 74, 1)",
              monthlyDiffHover,
            ],
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: { display: false },
          // Si quisieras usar la etiqueta en el centro:
          // doughnutLabel: {
          //   text: {
          //     title: pocketTitle,
          //     value: `$${totalAfter3Years.toLocaleString()}`,
          //   },
          // },
        },
      },
    };

    const ctx = canvas.getContext("2d");
    this.createOrUpdateChart(ctx, chartData, "firstChart");
  }

  updateSecondChart(canvas, model) {
    if (!canvas) return;

    const equityOnPayments = model.calcEquityOnNewHomePayments;
    const appreciatedValue = model.appreciatedValueAfter3Years;
    const downPayment = model.downPayment;

    const avColor =
      appreciatedValue >= 0
        ? "rgba(75, 192, 192, 0.7)"
        : "rgba(255, 206, 86, 0.7)";
    const avHover =
      appreciatedValue >= 0
        ? "rgba(75, 192, 192, 1)"
        : "rgba(255, 206, 86, 1)";

    const chartData = {
      type: "doughnut",
      data: {
        labels: ["Equity from Value Appreciation", "Down Payment", "Equity on Payments"],
        datasets: [
          {
            data: [
              Math.abs(appreciatedValue),
              downPayment,
              equityOnPayments,
            ],
            backgroundColor: [
              avColor,
              "rgba(54, 162, 235, 0.7)",
              "rgba(255, 206, 86, 0.7)",
            ],
            hoverBackgroundColor: [
              avHover,
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
            ],
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: { display: false },
        },
      },
    };

    const ctx = canvas.getContext("2d");
    this.createOrUpdateChart(ctx, chartData, "secondChart");
  }

  createOrUpdateChart(ctx, chartData, chartInstanceName) {
    if (!ctx) return;

    if (this[chartInstanceName]) {
      this[chartInstanceName].data = chartData.data;
      this[chartInstanceName].options = chartData.options;
      this[chartInstanceName].update();
    } else {
      if (Chart.getChart(ctx)) {
        Chart.getChart(ctx).destroy();
      }
      this[chartInstanceName] = new Chart(ctx, chartData);
    }
  }
}
